import { Theme } from '@material-ui/core';

export const usePickerErrorsStyles = ((theme: Theme) => ({
  errorChip:{
    '& .MuiChip-label':{
      color:'#C8372D'
    },
    '&.MuiChip-root':{
      backgroundColor:'#FEE8E7 !important',
    },
    '&.MuiChip-root .MuiSvgIcon-root path': {
      fill:'#C8372D'
    },
  },
}));
